/*
 * Copyright (c) 2024-2025 Hardfin, Inc.
 */

/**
 * API endpoint for uploading files associated with assets.
 * Provides functionality to attach documents, images, or other files
 * to specific assets in the system.
 */
import { uploadFile } from '@/file/api/upload-file';

/**
 * Uploads a ticket file to the server with the specified context and attributes.
 *
 * @param {string} id - The unique identifier of the ticket entity the file is associated with.
 * @param {File} file - The file object to be uploaded.
 * @return {Promise<Object>} A promise that resolves with the response of the upload action.
 */
export async function uploadTicketFile(id: string, file: File) {
  return uploadFile(file, {
    context: 'TICKET_FILE',
    isPublic: false,
    entityId: id,
  });
}
